import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAdminChangePaymentSystemResponse } from '../types';
import {
  ADMIN_PAYMENT_SYSTEM_DETAILS_SHOW_API_URL,
  ADMIN_PAYMENT_SYSTEM_DETAILS_SHOW_QUERY_KEY,
  PAYMENT_SYSTEM_DETAILS_PERMISSIONS,
} from '../constants';

export default function useAdminPaymentSystemShowQuery(id: Ref<number | undefined>): IContextQueryResult<IAdminChangePaymentSystemResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAdminChangePaymentSystemResponse>({
    queryKey: [ADMIN_PAYMENT_SYSTEM_DETAILS_SHOW_QUERY_KEY, id],
    queryFn: ({ signal }) => fetchGet<IAdminChangePaymentSystemResponse>(
      ADMIN_PAYMENT_SYSTEM_DETAILS_SHOW_API_URL,
      {
        signal,
        permission: PAYMENT_SYSTEM_DETAILS_PERMISSIONS.SHOW,
        urlParams: {
          id: id.value,
        },
      },
    ),
    enabled: computed(() => !!id.value),
    placeholderData: keepPreviousData,
  });
}
